export class CtaBar {
  private el: HTMLDivElement;
  private msg: HTMLSpanElement;
  private pill: HTMLSpanElement;
  constructor(parent: HTMLElement) {
    this.el = document.createElement('div');
    this.el.className = 'cta-bar';
    this.msg = document.createElement('span');
    this.pill = document.createElement('span');
    this.pill.className = 'pill';
    this.el.append(this.msg, this.pill);
    parent.append(this.el);
    this.hide();
  }
  set(message: string, cta: string): void {
    this.msg.textContent = message;
    this.pill.textContent = cta;
    this.pill.style.display = cta ? '' : 'none';
    this.el.style.display = '';
  }
  hide(): void { this.el.style.display = 'none'; }
}
